import logo from "../../assets/images/logo.svg";
import "../../styles/signinpage.css";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const SigninPage = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "Email is invalid";
    }
    if (!data.password.trim()) {
      errors.password = "Password is required";
    } else if (data.password.length < 8) {
      errors.password = "Password must be at least 8 characters";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors({});
    const errors = validateForm(formData);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setIsSubmitting(true);
      try {
        // API call
        const response = await axios.post(
          `${baseUrl}/api/v1/auth/login`,
          formData,
          {
            withCredentials: true,
          }
        );

        if (response.status === 200) {
          // Reset form after successful submission
          // setFormData({ email: "", password: "" });
          // Redirect to dashboard
          setTimeout(() => {
            navigate("/dashboard"); // Navigate to the dashboard
          }, 2000); // 2-second delay
        } else {
          setFormErrors({
            submit:
              response.data.message || "Sign-in failed. Please try again.",
          });
        }
      } catch (error) {
        setFormErrors({
          submit:
            error.response?.data?.message ||
            "Sign-in failed. Please try again.",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div className="container-signin">
      <Link to="/">
        <div className="flex items-center space-x-2 pt-10">
          <img src={logo} alt="AgroLink" className="h-8" />
        </div>
      </Link>
      <div className="content2-signin">
        <div className="content2div1-signin">
          <span>Welcome Back</span>
          <h4>Enter your credentials to access your account</h4>
        </div>
        <div>
          <form onSubmit={handleSubmit} className="form-container" noValidate>
            {/* Email */}
            <div className="form-group">
              <label htmlFor="email" className="sr-only">
                Email Address
              </label>
              <div className="icon-input-wrapper">
                <FaEnvelope className="input-icon" />
                <input
                  id="email-signin"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="icon-input"
                  aria-describedby="email-error"
                />
              </div>
              {formErrors.email && (
                <span id="email-error" className="error">
                  {formErrors.email}
                </span>
              )}
            </div>

            {/* Password */}
            <div className="form-group">
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <div className="icon-input-wrapper">
                <FaLock className="input-icon" />
                <input
                  id="password-signin"
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="icon-input"
                  aria-describedby="password-error"
                />
              </div>
              {formErrors.password && (
                <span id="password-error" className="error">
                  {formErrors.password}
                </span>
              )}
            </div>

            {/* Forgot Password and Signup Links */}
            <div className="form-links">
              <a href="/forgot-password" className="forgot-password-link">
                Forgot your password?
              </a>
              <p>
                Don't have an account?{" "}
                <Link to="/signup" className="signup-link">
                  Create an account
                </Link>
              </p>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="full-width"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Signing In..." : "Sign In"}
            </button>
            {formErrors.submit && (
              <span className="error submit-error">{formErrors.submit}</span>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default SigninPage;
